import React from "react";
import { useSelector } from "react-redux";
import InnerNavbar from "shared/InnerNavbar";
import Router from "./Router";
import styles from "./Account.module.scss";

const accountTabs = [
    {
        to: "/account/addresses",
        label: "Addresses",
        hash: "addesses",
    },
    {
        to: "/account/payment-methods",
        label: "Payment methods",
        hash: "payment-methods",
    },
    {
        to: "/account/notifications",
        label: "Notifications",
        hash: "notifications",
    },
    {
        to: "/account/profile",
        label: "Profile details",
        hash: "profile",
    },
    {
        to: "/account/birthday",
        label: "Birthday",
        hash: "birthday",
    },
];

const Account = () => {
    const membershipNumber = useSelector((s) => s.loyalty.account?.number);
    return (
        <div>
            <p className={`gkit-h2 gkit-sm-h3 ${styles.title}`}>Account</p>
            {membershipNumber && (
                <p className={styles.membershipNumber}>
                    Membership number: <strong>{membershipNumber}</strong>
                </p>
            )}

            <InnerNavbar tabs={accountTabs} Router={Router} />
            <div className={styles.desktopContent}>
                <Router />
            </div>
        </div>
    );
};

export default Account;
